import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-1" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-gray-100",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = { class: "default-table-area style-two campaigns-table customer-ratings-table px-20" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table border-0" }
const _hoisted_10 = {
  class: "fs-12 fw-semibold text-body-color-50 border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_11 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex-grow-1 ms-2" }
const _hoisted_16 = { class: "fs-14 fw-semibold mb-0 text-secondary-50" }
const _hoisted_17 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_18 = { class: "d-flex align-items-center gap-1" }
const _hoisted_19 = { class: "fs-12 fw-semibold text-body position-relative top-1" }
const _hoisted_20 = {
  class: "border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_21 = { class: "fs-12 fw-semibold text-secondary mb-1" }
const _hoisted_22 = {
  class: "fs-12 text-body",
  style: {"max-width":"617px","line-height":"1.8"}
}
const _hoisted_23 = {
  class: "fs-12 fw-semibold text-body border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_24 = {
  class: "text-end border-border-color-50",
  style: {"padding-top":"17px","padding-bottom":"17px"}
}
const _hoisted_25 = { class: "d-flex justify-content-end align-items-center gap-2" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap mt-3" }
const _hoisted_30 = { class: "fs-12 fw-medium" }
const _hoisted_31 = { "aria-label": "Page navigation example" }
const _hoisted_32 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_33 = { class: "page-item" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "page-item" }
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "mb-0" }, "Customer Reviews", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedRatingFilter || "Top Rated"), 1),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterByRating(5)))
              }, " 5 Star ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterByRating(4)))
              }, " 4 Star ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterByRating(3)))
              }, " 3 Star ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterByRating(2)))
              }, " 2 Star ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterByRating(1)))
              }, " 1 Star ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item text-secondary py-2 px-3",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearRatingFilter && _ctx.clearRatingFilter(...args)))
              }, " Clear Filter ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-bottom" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " USER ID ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " CUSTOMER NAME ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " RATINGS ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " REVIEWS ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " DATE ")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end bg-transparent opacity-0"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-bold letter-spacing-1" }, " ACTION ")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedReviews, (review) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: review.id
                }, [
                  _createElementVNode("td", _hoisted_10, " #" + _toDisplayString(review.id.toString().padStart(3, "0")), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: review.avatar,
                          class: "rounded-circle",
                          style: {"width":"30px","height":"30px"},
                          alt: "user"
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h4", _hoisted_16, _toDisplayString(review.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "text-danger ri-star-fill" }, null, -1)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(review.rating.toFixed(1)), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("h4", _hoisted_21, _toDisplayString(review.title), 1),
                    _createElementVNode("p", _hoisted_22, _toDisplayString(review.content), 1)
                  ]),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatDate(review.date)), 1),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.viewReview(review))
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, "visibility", -1)
                      ]))], 8, _hoisted_26),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.editReview(review))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary-div-50" }, "edit", -1)
                      ]))], 8, _hoisted_27),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.deleteReview(review.id))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                      ]))], 8, _hoisted_28)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, "Showing " + _toDisplayString(_ctx.showingRange) + " of " + _toDisplayString(_ctx.filteredReviews.length) + " Results", 1),
          _createElementVNode("nav", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              _createElementVNode("li", _hoisted_33, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_34)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_35)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_36, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_37)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}